import gql from 'graphql-tag';

const QUERY_CITIES_TAG = gql`
  query Cities($locale: CityLocale!) {
    cities {
      id
      currencyIsoCode
      cityName(locale: $locale)
    }
  }
`;

export const getCitiesQuery = client => locale =>
  client.query({
    query: QUERY_CITIES_TAG,
    fetchPolicy: 'cache-first',
    variables: {
      locale
    }
  });

export default { getCitiesQuery };
